import { render, staticRenderFns } from "./r-reminder-table.vue?vue&type=template&id=6bd0ae40"
import script from "./r-reminder-table.vue?vue&type=script&lang=js"
export * from "./r-reminder-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd0ae40')) {
      api.createRecord('6bd0ae40', component.options)
    } else {
      api.reload('6bd0ae40', component.options)
    }
    module.hot.accept("./r-reminder-table.vue?vue&type=template&id=6bd0ae40", function () {
      api.rerender('6bd0ae40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reminder/r-reminder-table.vue"
export default component.exports